///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    // If js-seconds-counter class is present, increment counter.
    if (document.querySelector('.js-seconds-counter')) {
      // We store the interval in a var to be able to conditionally clear it
      // once sync process is complete.
      const counterInterval = setInterval(() => {
        const countElement = document.querySelector('.js-seconds-counter-count'),
              messageElement = document.querySelector('.js-seconds-counter-message');

        let currentCount = countElement.innerText;

        countElement.innerText = ++currentCount;

        if (currentCount == 6) {
          messageElement.innerText = 'Still working, please hang tight...';
        } else if (currentCount == 15) {
          messageElement.innerText = 'Taking longer than expected, please hang tight...';
        }

        // If counter-related HTML has been hidden, we've reached the end of
        // the attempted sync process, so we stop the interval.
        if (countElement.parentElement.parentElement.classList.contains('d-none')) {
          clearInterval(counterInterval);
        }
      }, 1000);
    }
  });
}());
